import { Controller } from "@hotwired/stimulus"

// Add/remove rows for a jsonb-backed array field with no real AR association
// to hang fields_for off of. Each new row's inputs are indexed by a unique
// timestamp so the server groups them back into one array entry per row.
export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()

    const index = Date.now()
    const html = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", index)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-repeater-target='row']").remove()
  }
}
